// extracted by mini-css-extract-plugin
module.exports = {"buttonText":"button-all-services_buttonText__2awWG","profileWidget":"button-all-services_profileWidget__GH3GL"};